<i18n>
  {
  "en": {
  },
  "ua": {
  },
  "ru": {
  }
  }
</i18n>

<template>
  <div>
    <component
      :is="require('./components/_snippets/spinner/spinner_002').default"
    ></component>
    <el-container
      style="height: 100vh; border: 1px solid #eee"
      :class="{ 'is-loading': $store.state.app.loading }"
    >
      <component
        :is="require('./components/menu/app_aside').default"
        v-if="user.token || true"
      />
      <el-container direction="vertical">
        <component
          :is="require('./components/header/app_header').default"
          :user="user"
        ></component>
        <router-view />
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  methods: {
    toggle() {
      setTimeout(() => {
        this.$store.commit("user/toggleLogged");
        this.toggle();
      }, 2000);
    }
  },
  computed: mapState(["user"])
};
</script>

<style lang="stylus">
body {
  background-color: #f5f5f5;
}

.el-header {
  color: #333;
  background-color: #fff;
  line-height: 60px;
  // border-bottom: 1px solid #e8eaeb;
}

.el-button {
  .material-design-icon {
    height: auto;
  }
}

.w-status {
  i {
    &.w--enabled {
      color: #00b75c;
    }

    &.w--disabled {
      color: #d8d8d8;
    }

    &.w--broken {
      color: #d6000e;
    }
  }
}
</style>
